import { DashboardTeamMemberRole } from "@/api/__generated__/schemas";
import { fromApiDate, TeamFragment } from "@/graphql";
import { mapToCountryCodeNullable } from "@/mappers/common.mappers";
import { mapToDiscipline } from "@/mappers/discipline.mappers";
import { mapToSport } from "@/mappers/sport.mappers";
import { mapToUser } from "@/mappers/user.mappers";
import { Team, TeamJoinedFrom, TeamMemberRole } from "@/types/team.types";

export const mapToTeam = (fragment: TeamFragment): Team => ({
  id: String(fragment.id!),
  title: fragment.title ?? "",
  image: fragment.image ?? null,
  country: fragment.country ? mapToCountryCodeNullable(fragment.country) : null,
  createdBy: fragment.createdBy ? mapToUser(fragment.createdBy) : null,
  email: fragment.email || null,
  facebookLink: fragment.facebookLink || null,
  instagramLink: fragment.instagramLink || null,
  phone: fragment.phone || null,
  tiktokLink: fragment.tiktokLink || null,
  twitterLink: fragment.twitterLink || null,
  website: fragment.website || null,
  sport: fragment.sport ? mapToSport(fragment.sport) : null,
  joinedFrom: fragment.joinedFrom ? mapToTeamJoinedFrom(fragment.joinedFrom) : null,
  createdAt: fragment.createdAt ? fromApiDate(fragment.createdAt) : null,
  discipline: fragment.discipline ? mapToDiscipline(fragment.discipline) : null,
});

const TEAM_MEMBER_ROLE_FROM_API: { [K in DashboardTeamMemberRole]: TeamMemberRole } = {
  captain: "captain",
  playingCaptain: "playingCaptain",
  coach: "coach",
  doctor: "doctor",
  player: "player",
  staff: "staff",
};

export const mapToTeamMemberRole = (role: DashboardTeamMemberRole): TeamMemberRole =>
  TEAM_MEMBER_ROLE_FROM_API[role];

export const mapToApiTeamMemberRole = (role: TeamMemberRole): DashboardTeamMemberRole => {
  switch (role) {
    case "captain":
      return DashboardTeamMemberRole.captain;
    case "coach":
      return DashboardTeamMemberRole.coach;
    case "doctor":
      return DashboardTeamMemberRole.doctor;
    case "player":
      return DashboardTeamMemberRole.player;
    case "playingCaptain":
      return DashboardTeamMemberRole.playingCaptain;
    case "staff":
      return DashboardTeamMemberRole.staff;
  }
};

export const mapToTeamJoinedFrom = (joinedFrom: string): TeamJoinedFrom | null => {
  switch (joinedFrom.toLowerCase()) {
    case "web":
    case "web app":
      return "web";
    case "mobile":
      return "mobile";
    case "invite":
      return "invite";
    default:
      return null;
  }
};
